var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"RewardsTitle"}},[_c('hr'),_c('div',{attrs:{"id":"title"}},[_vm._v("\r\n      "+_vm._s(_vm.title)+"\r\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }